var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fictitious_box"},[(_vm.iframeSrc)?_c('iframe',{staticClass:"fictitious_iframe",attrs:{"src":_vm.iframeSrc,"id":"fictitious_iframe"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }